import { render, staticRenderFns } from "./my-order-history.vue?vue&type=template&id=98ab2402&scoped=true&"
import script from "./my-order-history.vue?vue&type=script&lang=js&"
export * from "./my-order-history.vue?vue&type=script&lang=js&"
import style0 from "./my-order-history.vue?vue&type=style&index=0&id=98ab2402&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ab2402",
  null
  
)

export default component.exports